









































































import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { MedicationInstructionPayload } from '@/api/medicationInstruction/types'
import InputGroup from '@/mixins/form/inputGroup'

@Component({
  components: {
    SelectInput: () => import('@/components/common/inputs/SelectInput.vue'),
    RadioInput: () => import('@/components/common/inputs/RadioInput2.vue')
  }
})
export default class ExcretionInputGroup extends mixins(InputGroup) {
  @Prop(Object) inputs!: MedicationInstructionPayload

  get excretionDaytimeUrinationCountOptions() {
    return [...new Array(201)].map((_, i) => i)
  }

  get excretionNighttimeUrinationCountOptions() {
    return [...new Array(201)].map((_, i) => i)
  }

  get excretionBowelMovementOptions() {
    return [
      { label: '快便', value: 1 },
      { label: '便秘', value: 2 },
      { label: '下痢', value: 3 }
    ]
  }

  get excretionSweatingOptions() {
    return [
      { label: '少', value: 1 },
      { label: '普通', value: 2 },
      { label: '多', value: 3 }
    ]
  }
}
